import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { ExpiredCertificateInterface } from "../interfaces/ExpiredCertificateInterface";
import { MetaInterface } from "../interfaces/MetaInterface";
import { ApiEnum } from "../enums/ApiEnum";
import { createQueryString } from "../utils/createQueryString";

type ExpiredCertificatesResponse = {
    data: ExpiredCertificateInterface[];
    meta?: MetaInterface;
    message?: string;
};

type ExpiredCertificatesPagination = {
    page?: number;
    items_per_page?: number;
};

export const expiredCertificateApiSlice = createApi({
    reducerPath: "expiredCertificateApiSlice",
    baseQuery: apiBaseQuery(),
    tagTypes: ["ExpiredCertificate"],
    endpoints: (builder) => ({
        getEmployeeExpiredCertificates: builder.query<
            ExpiredCertificatesResponse,
            ExpiredCertificatesPagination
        >({
            query: (values) => ({
                url: `${ApiEnum.EMPLOYEE_EXPIRED_CERTIFICATE}?${createQueryString(values)}`,
                method: "GET",
            }),
            providesTags: ["ExpiredCertificate"],
        }),
        getEstablishmentExpiredCertificates: builder.query<
            ExpiredCertificatesResponse,
            ExpiredCertificatesPagination & { establishmentId: number }
        >({
            query: ({ establishmentId, ...values }) => ({
                url: `${ApiEnum.ESTABLISHMENT_EXPIRED_CERTIFICATE}/${establishmentId}/expired-certificate?${createQueryString(values)}`,
                method: "GET",
            }),
            providesTags: ["ExpiredCertificate"],
        }),
    }),
});

export default expiredCertificateApiSlice.reducer;

export const {
    useGetEmployeeExpiredCertificatesQuery,
    useGetEstablishmentExpiredCertificatesQuery,
} = expiredCertificateApiSlice;
